<template>
  <div
    class="scs-color-set"
    :style="{
      'z-index': pickerOpen ? '3' : '',
    }"
  >
    <h5 v-if="heading">{{ heading }}</h5>
    <div class="scs-colors" @click="togglePicker">
      <color-picker
        v-for="(color, index) in initial"
        :key="index"
        :color="color"
      />
      <div
        class="scs-color-options"
        v-if="pickerOpen"
        :style="{ [vertical]: 'calc(100% + 15px)' }"
      >
        <div
          class="scs-colors"
          v-for="(option, index) in options"
          :key="index"
          @click="chooseColorSet(option)"
        >
          <color-picker
            v-for="(color, index) in option"
            :key="index"
            :color="color"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ColorPicker from "./ColorPicker.vue";
import { preferentialVerticalProperty } from "../../../Helpers/style.js";
export default {
  data() {
    return {
      pickerOpen: false,
      vertical: "top",
    };
  },
  computed: {},
  methods: {
    togglePicker($event) {
      this.vertical = preferentialVerticalProperty($event);
      this.pickerOpen = !this.pickerOpen;
    },
    chooseColorSet(set) {
      this.$emit("scs-input", set);
    },
  },
  created() {},
  components: {
    ColorPicker,
  },
  props: ["initial", "options", "heading"],
  emits: ["scs-input"],
};
</script>
<style scoped>
.scs-color-set {
  display: flex;
  flex-direction: column;
  z-index: 1;
}

h5 {
  margin: 10px;
}

.scs-colors {
  display: flex;
}

.scs-colors:hover {
  filter: drop-shadow(0 0 4px var(--shadow));
}

.scs-color-options {
  position: absolute;
  z-index: 2;
  left: -5px;
  background-color: var(--backgroundColor);
  filter: drop-shadow(0 0 2px var(--shadow));
  padding: 5px;
}
</style>
